module.exports = __webpack_public_path__ + "img/train_car.68e009f0.jpg";